(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
     document.addEventListener("DOMContentLoaded", function() {
      let acc = document.getElementsByClassName("faq-question");
      let i;

        for (i = 0; i < acc.length; i++) {
          acc[i].addEventListener("click", function() {

          this.classList.toggle("faq-expanded");


          let chevron = this.querySelector('.svg-arrow-faq');
          chevron.classList.toggle('rotate-effect');

          let faqAnswer = this.nextElementSibling;

          if (faqAnswer.style.display === "block") {
              faqAnswer.style.display = "none";
          } else {
              faqAnswer.style.display = "block";
          }
      });
  }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
